'use es6';

import { Record } from 'immutable';
import ContentRoutes from 'ContentUtils/Routes';
import DesignAssetTypes from 'ContentUtils/constants/DesignAssetTypes';
import { ContentTypes, LayoutLinkTypes, RequestStatus } from '../constants/base';
const DEFAULTS = {
  isStarterTemplate: false,
  label: '',
  status: RequestStatus.UNINITIALIZED,
  url: ''
};
const getUrl = data => {
  const {
    assetSource,
    builtIn,
    linkType,
    href,
    path
  } = data;
  let {
    assetId,
    assetType
  } = data;
  if (assetId === undefined) {
    assetId = builtIn ? href : data.id;
  }
  if (assetType === undefined) {
    assetType = linkType === LayoutLinkTypes.LAYOUT ? DesignAssetTypes.LAYOUT : DesignAssetTypes.TEMPLATE;
  }
  return ContentRoutes.designManager(assetId, assetType, assetSource, path);
};
const getUrlFromResponseData = (contentType, data) => {
  if (contentType === ContentTypes.BLOG_POST) {
    let assetId;
    let assetType;
    const {
      body,
      id,
      layoutData
    } = data;
    if (layoutData) {
      assetId = id;
      assetType = DesignAssetTypes.LAYOUT;
    } else if (body && body.generatedFromLayoutId) {
      assetId = body.generatedFromLayoutId;
      assetType = DesignAssetTypes.LAYOUT;
    }
    return getUrl(Object.assign({}, data, {
      assetId,
      assetType
    }));
  }
  return getUrl(data);
};
class Template extends Record(DEFAULTS) {
  static fromJS(contentType, data) {
    return new Template({
      isStarterTemplate: data.templateType === 39,
      label: data.displayName || data.label,
      status: RequestStatus.SUCCEEDED,
      url: getUrlFromResponseData(contentType, data)
    });
  }
}
export default Template;